"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveUserServiceEndpoint = exports.ArchiveUserServiceEndpoint = exports.PatchUserServiceEndpoint = exports.CreateUserServiceEndpoint = void 0;
exports.CreateUserServiceEndpoint = require("./create-user-service");
exports.PatchUserServiceEndpoint = require("./patch-user-service");
exports.ArchiveUserServiceEndpoint = require("./archive-user-service");
exports.RemoveUserServiceEndpoint = require("./remove-user-service");
